export const URL_TYPE = 'session';
export const URL_TOKEN = 'pwd';